import React from 'react';
import { ReviewHero } from '../components/ReviewHero';
import { QuickFacts } from '../components/QuickFacts';
import { ReviewCategory } from '../components/ReviewCategory';
import { TestimonialCard } from '../components/TestimonialCard';
import { ProsConsSection } from '../components/ProsConsSection';
import { VerdictSection } from '../components/VerdictSection';
import { AboutSection } from '../components/AboutSection';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';
export function ReviewPage() {
  // Structured data for Google Rich Results
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Review',
    itemReviewed: {
      '@type': 'SoftwareApplication',
      name: 'CRM Kraft',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'EUR'
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.5',
        bestRating: '5',
        ratingCount: '110'
      }
    },
    author: {
      '@type': 'Organization',
      name: 'CRMReview.de'
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: '4.5',
      bestRating: '5'
    },
    reviewBody: 'CRM Kraft ist ein hochspezialisiertes KI-gestütztes CRM-System für Vertriebsautomatisierung. Mit über 110 Kunden und €7M+ generiertem Umsatz bietet es Lead-Priorisierung, automatisches Follow-up und Echtzeit-Verkaufsprognosen. Besonders geeignet für B2B-Unternehmen mit Vertriebsteams.'
  };
  const categories = [{
    title: 'Funktionen & Features',
    rating: 4.5,
    description: 'Der Funktionsumfang ist beeindruckend, besonders durch die KI-Integration.',
    points: ['KI-gestützte Lead-Priorisierung funktioniert zuverlässig', 'Automatische Follow-up Sequenzen sparen enorm Zeit', 'Echtzeit-Verkaufsprognosen für bessere Planung', 'Umfassendes Pipeline-Management']
  }, {
    title: 'Benutzerfreundlichkeit',
    rating: 4.5,
    description: 'Trotz komplexer Funktionen bleibt die Oberfläche übersichtlich und intuitiv.',
    points: ['Intuitive Bedienung ohne langes Handbuch-Studium', 'Sehr schnelle Implementierung in bestehende Prozesse', 'Persönliches Onboarding erleichtert den Start', 'Keine steile Lernkurve für neue Mitarbeiter']
  }, {
    title: 'Preis-Leistungs-Verhältnis',
    rating: 4.0,
    description: 'Nicht die günstigste Lösung am Markt, aber der ROI rechtfertigt die Investition.',
    points: ['Keine versteckten Kosten', 'ROI von 20-50% Umsatzsteigerung im ersten Jahr realistisch', 'Enorme Zeitersparnis (bis zu 60%) bei Routineaufgaben', 'Unbegrenzte Kontakte inklusive']
  }, {
    title: 'Kundensupport',
    rating: 5.0,
    description: 'Hier glänzt CRM Kraft besonders. Der Support ist persönlich und kompetent.',
    points: ['Persönlicher Support direkt vom Gründer und Experten', 'Keine anonymen Support-Tickets oder Chatbots', 'Kostenlose Erstberatung zur Bedarfsanalyse', 'Gefühl einer echten Partnerschaft statt nur Dienstleistung']
  }, {
    title: 'Integration & Technologie',
    rating: 4.5,
    description: 'Technisch auf dem neuesten Stand und sicher.',
    points: ['Basiert auf dem bewährten Close CRM', 'Deutsche Server garantieren DSGVO-Konformität', 'Enterprise-Grade Sicherheitsstandards', 'Moderne KI-Technologie sinnvoll integriert']
  }];
  const testimonials = [{
    quote: 'Wir haben 100.000 € extra jeden Monat allein durch das Follow-Up generiert.',
    author: 'Luis Warkuss',
    initial: 'L'
  }, {
    quote: 'Wir sind von 250.000 € auf über 450.000 € Monatsumsatz gewachsen.',
    author: 'Henri CL',
    initial: 'H'
  }, {
    quote: 'Wir haben unsere Umsätze verdreifacht bis verfünffacht – ohne unser Vertriebsteam massiv ausbauen zu müssen.',
    author: 'Steuer Mentoring',
    company: 'Steuer Mentoring',
    initial: 'S'
  }];
  return <>
      <SEO title="CRM Kraft Test 2025: Ehrliche Bewertung & Erfahrungen" description="CRM Kraft im Test: Unabhängige Bewertung des KI-gestützten CRM-Systems. Funktionen, Preise, Vor- und Nachteile. 4.5/5 Sterne ⭐ Über 110 Kunden ✓ €7M+ Umsatz generiert" keywords="CRM Kraft, CRM Kraft Bewertungen, CRM Kraft Test, CRM Kraft Erfahrungen, CRM Kraft Review, Close CRM, Vertriebsautomatisierung, KI CRM, Lead-Priorisierung" canonicalUrl="/reviews/crm-kraft" structuredData={structuredData} data-id="element-347" />

      <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-348">
        {/* Navigation Placeholder */}
        <nav className="border-b border-slate-200 bg-white sticky top-0 z-50" data-id="element-349">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-350">
            <Link to="/" className="font-bold text-xl tracking-tight hover:opacity-80 transition-opacity" data-id="element-351">
              CRM<span className="text-blue-600" data-id="element-352">Review</span>
              <span className="text-slate-400 font-normal" data-id="element-353">.de</span>
            </Link>
            <div className="text-sm font-medium text-slate-500" data-id="element-354">
              Unabhängige Software-Tests
            </div>
          </div>
        </nav>

        <main data-id="element-355">
          <ReviewHero data-id="element-356" />
          <QuickFacts data-id="element-357" />

          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-358">
            <div className="flex items-center mb-8" data-id="element-359">
              <div className="h-8 w-1 bg-blue-600 rounded-full mr-4" data-id="element-360"></div>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-361">
                Detaillierte Bewertung
              </h2>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-362">
              {categories.map((cat, idx) => <ReviewCategory key={idx} title={cat.title} rating={cat.rating} description={cat.description} points={cat.points} data-id="element-363" />)}
            </div>

            <div className="flex items-center mb-8" data-id="element-364">
              <div className="h-8 w-1 bg-blue-600 rounded-full mr-4" data-id="element-365"></div>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-366">
                Das sagen Kunden
              </h2>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-367">
              {testimonials.map((t, idx) => <TestimonialCard key={idx} quote={t.quote} author={t.author} initial={t.initial} company={t.company} data-id="element-368" />)}
            </div>
          </div>

          <ProsConsSection data-id="element-369" />
          <AboutSection data-id="element-370" />
          <VerdictSection data-id="element-371" />
        </main>

        <footer className="bg-slate-50 border-t border-slate-200 py-12 mt-12" data-id="element-372">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-500 text-sm" data-id="element-373">
            <div className="flex justify-center space-x-6 mb-4" data-id="element-374">
              <Link to="/impressum" className="hover:text-slate-900 transition-colors" data-id="element-375">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-slate-900 transition-colors" data-id="element-376">
                Datenschutz
              </Link>
            </div>
            <p className="mb-4" data-id="element-377">
              © {new Date().getFullYear()} CRMReview.de - Alle Rechte
              vorbehalten.
            </p>
            <p data-id="element-378">
              Hinweis: Wir finanzieren uns teilweise durch Affiliate-Links. Dies
              hat keinen Einfluss auf unsere redaktionelle Unabhängigkeit und
              Bewertung.
            </p>
          </div>
        </footer>
      </div>
    </>;
}